define(function (require) {
	const tpl = require('./templates/t_cpv_grid_table.hbs');
	const childView = require('./v_cpv_grid_row');
	const utils = require('civicsUtils/general_utilities');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');

	return Marionette.CompositeView.extend({
		childViewContainer: '.grid-rows-container',
		childView:childView,
		template: tpl,
		childEvents: {
			'deleteRowClicked': function (childView, values) { this.triggerMethod('deleteRowButtonClicked', values); },
			'editRowClicked': function (childView, values) { this.triggerMethod('editRowButtonClicked', values); }
		},
		initialize: function (options) {
			this.config = options.config;
		},
		onRender: function () {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
		},
		childViewOptions: function (model, index) {
			//we need to sever the model here to prevent changes in one row's model propogating to other rows.
			var elements = new IpsModelCollection(this.model.get('elements').toJSON());
			var ret = {
				config: this.config,
				isGrid: true,
				//note the this.model. We are setting the collection = to the elements of the grid, NOT the values, which are in model.
				collection: elements,
				values:model
			};
			return ret;
		},
		templateHelpers: function () {
			return {
				gridBind: this.model.get('bind'),
				canAddRows: this.config.canAddRows,
				showRequired: this.config.readOnlyForm == false,
				hasNoDescription: function(description) {
					return _.isEmpty(description ? description.trim() : '');
				},
				getTooltip: function(tooltipString) {
					return tooltipString ? utils.attributeEscapeString(tooltipString) : '';
				},
				classes: 'grid-table' + (!this.config.isEnabled ? ' disabled' : ''),
				showEmptyMsg: this.collection.length == 0? true : false
			}
		},
		getData: function () {
			var gridData = {};
			gridData[this.model.get('bind')] = this.collection.toJSON();
			return gridData;
		}
	});
});
